import React from 'react';
import {
  IconButton, Tooltip, Box, SxProps, Theme,
} from '@mui/material';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import { useChartExceptionContext } from '../../../../../context/ChartExceptionContext';

interface ChartExceptionButtonProps {
  sx?: SxProps<Theme>;
}

function ChartExceptionButton({ sx = {} }: ChartExceptionButtonProps) {
  const chartExceptionContext = useChartExceptionContext();

  if (!chartExceptionContext) return null;

  const {
    isExceptionToolActive, pendingRanges, activateExceptionTool, clearPendingRanges,
  } = chartExceptionContext;
  const hasPendingRanges = pendingRanges.length > 0;

  const handleClick = () => {
    if (hasPendingRanges) {
      clearPendingRanges();
    } else {
      activateExceptionTool();
    }
  };

  const getTooltipTitle = () => {
    if (!isExceptionToolActive && !hasPendingRanges) {
      return 'Excepciones: arrastra en un gráfico para excluir rangos de datos';
    }
    if (hasPendingRanges) {
      return `${pendingRanges.length} rango(s) pendiente(s). Haz clic para limpiar`;
    }
    return 'Herramienta activa: arrastra en un gráfico para seleccionar un rango de excepción';
  };

  return (
    <Box sx={{
      ...sx,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
    }}>
      <Tooltip title={getTooltipTitle()}>
        <IconButton
          size="small"
          onClick={handleClick}
          sx={{
            padding: '4px',
            backgroundColor: isExceptionToolActive || hasPendingRanges
              ? 'rgba(255, 140, 0, 0.12)' : 'transparent',
          }}
        >
          <EventBusyIcon sx={{
            color: isExceptionToolActive || hasPendingRanges ? '#ff8c00' : '#385576',
            fontSize: '18px',
          }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
}

export default ChartExceptionButton;
